import React from 'react'
import Typography from '@mui/material/Typography'
import Typograf from 'typograf'

const typograf = new Typograf({ locale: [ 'ru', 'en-US' ] })
export {formatCopy as formatDemoCopy} from 'utils/typography'

typograf.disableRule([
  'common/nbsp/afterShortWord',
  'common/space/trimLeft',
  'common/space/trimRight',
  'common/space/delTrailingBlanks',
])

export const formatDemoScenarioTitle = (title?: string): React.ReactNode => {
  if (!title) {
    return title
  }

  const text = typograf.execute(title)
    .replace(/\s+(?=(?:\uD83C[\uDDE6-\uDDFF]){2})/g, '\u00a0')

  return text.split(/([ \t\r\n]+)/).map((part, index) => {
    if (!part || /^[ \t\r\n]+$/.test(part)) {
      return part
    }

    return (
      <Typography
        key={index}
        component='span'
        variant='inherit'
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          '@media (max-width: 575px)': {
            display: 'inline',
            whiteSpace: 'normal',
            hyphens: 'auto'
          }
        }}
      >
        {part}
      </Typography>
    )
  })
}
